import { useTranslation } from "hooks/useTranslation";
import { DynamicLink } from "shared/components/DynamicLink";
import styles from "../DropdownContent.module.scss";

const DOCUMENT_BASE_URL = process.env.REACT_APP_DOCUMENT_BASE_URL;

const DOWNLOAD_LINKS_NOT_FOR_DISTRIBUTION = [
  { isDisabled: false, title: '501 Traceability Integration (A4)', download: true, link: `${DOCUMENT_BASE_URL}sales-tools/501_Traceability_Integration_A4.pdf` },
  { isDisabled: false, title: 'Auto Flux Purge System Sales Sheet', download: true, link: `${DOCUMENT_BASE_URL}sales-tools/Auto_Flux_Purge_System_Sales_Sheet.pdf` },
  { isDisabled: false, download: true, title: 'Barcode and AOI 21-06-2023', link: `${DOCUMENT_BASE_URL}sales-tools/Barcode_and_AOI_21-06-2023.pdf` },
  { isDisabled: false, download: true, title: 'Camera Based Solder Nozzle Condition Sensing and Flow Control Sales Sheet', link: `${DOCUMENT_BASE_URL}sales-tools/Camera_Based_Solder_Nozzle_Condition_Sensing_and_Flow_control_Sales_Sheet.pdf` },
  { isDisabled: false, download: true, title: 'Flux head Sales Sheet', link: `${DOCUMENT_BASE_URL}sales-tools/Flux_Head_Sales_Sheet.pdf` },
  { isDisabled: false, download: true, title: 'Soldering Nozzle Technologies Sales Sheet', link: `${DOCUMENT_BASE_URL}sales-tools/Soldering_Nozzle_Technologies_Sales_Sheet.pdf` },
  { isDisabled: false, download: true, title: 'Preheat Technology Sales Sheet-SM', link: `${DOCUMENT_BASE_URL}sales-tools/Preheat_Technology_Sales_Sheet-SM.pdf` },
  { isDisabled: false, download: true, title: 'Selective Soldering Rework Strategies', link: `${DOCUMENT_BASE_URL}sales-tools/Selective_Soldering_Rework_Strategies.pdf` },
  { isDisabled: false, download: true, title: 'Software Improvements overall list V1', link: `${DOCUMENT_BASE_URL}sales-tools/Software_Improvements_overall_list_V1.pdf` },
  { isDisabled: false, download: true, title: 'Solder Pump Technology Sales Sheet', link: `${DOCUMENT_BASE_URL}sales-tools/Solder_Pump_Technology_Sales_Sheet.pdf` },
  { isDisabled: false, download: true, title: 'Solder Pump Technology Sales Sheet-German', link: `${DOCUMENT_BASE_URL}sales-tools/Solder_Pump_Technology_Sales_Sheet-German.pdf` },
  { isDisabled: false, download: true, title: 'Solder Pump Technology Sales Sheet-Japanese', link: `${DOCUMENT_BASE_URL}sales-tools/Solder_Pump_Technology_Sales_Sheet-Japanese.pdf` },
  { isDisabled: false, download: true, title: 'Solder Pump Technology Sales Sheet-Spanish', link: `${DOCUMENT_BASE_URL}sales-tools/Solder_Pump_Technology_Sales_Sheet-Spanish.pdf` },
];
const DOWNLOAD_LINKS = [
  { isDisabled: false, download: true, title: 'Quick Guide Pillarhouse Platforms', link: `${DOCUMENT_BASE_URL}sales-tools/Quick Guide.pdf` },
  { isDisabled: false, download: true, title: 'Advanced Selective Soldering Training', link: `${DOCUMENT_BASE_URL}sales-tools/SSA_Brochure.pdf` },
  { isDisabled: false, download: true, title: 'US Synchrodex Combo Brochure', link: `${DOCUMENT_BASE_URL}sales-tools/US_Synchrodex_Combo_Brochure.pdf` },
  { isDisabled: false, download: true, title: 'US Synchrodex Pro Brochure', link: `${DOCUMENT_BASE_URL}sales-tools/US_Synchrodex_Pro_Brochure.pdf` },
  { isDisabled: false, download: true, title: 'UK Smart Factory', link: `${DOCUMENT_BASE_URL}sales-tools/UK_Smart_Factory.pdf` },
  { isDisabled: false, download: true, title: 'US Accessories & Spares Brochure', link: `${DOCUMENT_BASE_URL}sales-tools/US_Accessories_and_Spares_Brochure.pdf` },
  { isDisabled: false, download: true, title: 'US Fusion Brochure', link: `${DOCUMENT_BASE_URL}sales-tools/US_Fusion_Brochure.pdf` },
  { isDisabled: false, download: true, title: 'US Jade MKII Brochure', link: `${DOCUMENT_BASE_URL}sales-tools/US_Jade_MKII_Brochure.pdf` },
  { isDisabled: false, download: true, title: 'US Master Brochure', link: `${DOCUMENT_BASE_URL}sales-tools/US_Master_Brochure.pdf` },
  { isDisabled: false, download: true, title: 'US PillarCARE Brochure', link: `${DOCUMENT_BASE_URL}sales-tools/US_PillarCARE_Brochure.pdf` },
  { isDisabled: false, download: true, title: 'US PillarGEN Brochure', link: `${DOCUMENT_BASE_URL}sales-tools/US_PillarGEN_Brochure.pdf` },
  { isDisabled: false, download: true, title: 'US Selective Soldering Systems Flyer', link: `${DOCUMENT_BASE_URL}sales-tools/US_Selective_Soldering_Systems_Flyer.pdf` },
  { isDisabled: false, download: true, title: 'US Synchrodex Brochure', link: `${DOCUMENT_BASE_URL}sales-tools/US_Synchrodex_Brochure.pdf` },
  { isDisabled: false, download: true, title: 'Pillarhouse Sample Process Request Form', link: `${DOCUMENT_BASE_URL}sales-tools/Pillarhouse Sample Process Request Form.docx` },
];

export const DownloadsDropdownContent = ({ closeDropdown }) => {
  const { translate } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.column1}>
        <div className={styles.titleBlock}>
          <h3 className={styles.title}>{translate("Technical Downloads (Not for Distribution)")}</h3>
        </div>
        <div className={styles.contentBlock}>
          <div className={styles.column1}>
            {DOWNLOAD_LINKS_NOT_FOR_DISTRIBUTION.map((dl, idx) => (
              <DynamicLink
                isDisabled={dl.isDisabled}
                onClick={closeDropdown}
                key={idx}
                href={dl.link}
                target="_blank"
                disabled={dl.highlighted || dl.isDisabled}
                className={`${styles.subTitle} ${
                  dl.highlighted && styles.highlighted
                } ${dl.isDisabled && styles.isDisabled}`}
              >
                {dl.title}
              </DynamicLink>
            ))}
          </div>
        </div>
      </div>
      <div className={styles.column2}>
        <div className={styles.titleBlock}>
          <h3 className={styles.title}>{translate("Technical Downloads (Open for Distribution)")}</h3>
        </div>
        <div className={styles.contentBlock}>
          <div className={styles.column2}>
            {DOWNLOAD_LINKS.map((dl, idx) => (
              <DynamicLink
                isDisabled={dl.isDisabled}
                onClick={closeDropdown}
                key={idx}
                href={dl.link}
                target="_blank"
                disabled={dl.highlighted || dl.isDisabled}
                className={`${styles.subTitle} ${
                  dl.highlighted && styles.highlighted
                } ${dl.isDisabled && styles.isDisabled}`}
              >
                {dl.title}
              </DynamicLink>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
};